export const A4_WIDTH_MM = 210;
export const A4_HEIGHT_MM = 297;
export const A4_WIDTH = 794;
export const A4_HEIGHT = 1123;
